module.exports = __webpack_public_path__ + "img/main-01-13.de4b30c1.png";